import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // Always go to the very top, ignoring any hash fragments
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  // include pathname + search so changing query also scrolls up
  }, [pathname, search, hash]);

  return null;
}
 